<app-formulario URL="tramite-anexo-ocho" titulo="Nuevo Registro Anexo 8"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns" style="height:100%; padding:0px;">

    <div class="column is-2 is-hidden-mobile menu-izquierda">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>

    <div class="tramite-container" style="padding:0px;">

        <div *ngIf="showLoadingOverlay" class="loading-overlay">
            <div class="loading-content">
                <div class="loading-spinner">
                    <i class="fas fa-spinner fa-spin fa-3x"></i>
                </div>
                <div class="loading-text">
                    <p>Trabajando, por favor espere...</p>
                </div>
            </div>
        </div>

        <div class="top-bar-card has-background-primary has-rounded-corners">
            <div class="level is-mobile" style="width: 100%; margin-bottom: 0;">
                <div class="level-left">
                    <div class="level-item">
                        <div class="title-container">
                            <span class="icon">
                                <i class="fas fa-file-alt fa-lg has-text-white"></i>
                            </span>
                            <h1 class="title is-4 has-text-white">Generar Anexo 8</h1>
                        </div>
                    </div>
                </div>

                <div class="level-right" >
                    <div class="level-item" >  
                        <form [formGroup]="tramiteForm" class="field has-addons" >
                            <div class="control" style="margin: 5px 5px 5px 5px;">
                                <div class="select">
                                    <select name="anio_preliminar" id="anio_preliminar" 
                                            formControlName="anio_preliminar">
                                        <option *ngFor="let anio of anios" [value]="anio.valor">
                                            {{ anio.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="control" style="margin: 5px 5px 5px 5px;">
                                <button class="button is-info" 
                                        (click)="consultarPreliminar()"
                                        [disabled]="isLoading"
                                        type="button">
                                    <span class="icon">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    <span>Consultar A8</span>
                                </button>
                            </div>
                            
                            <div class="control" style="margin: 5px 5px 5px 5px;">
                                <button class="button" 
                                        [class.is-loading]="isLoading"
                                        (click)="generarAnexoOcho()"
                                        type="button"
                                        [disabled]="isLoading || alumnosConFaltantes.length > 0">
                                    <span class="icon">
                                        <i class="fas fa-save"></i>
                                    </span>
                                    <span>Generar A8</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>  

        <div class="content-scrollable" style="background-color: #f5f5f0; padding:10px;">
            <div style="background-color: #EEF2F8; padding: 10px; padding-bottom: 2rem;">

                <div *ngIf="errorMessage" class="notification is-danger is-light">
                    <button class="delete" (click)="errorMessage = ''"></button>
                    {{ errorMessage }}
                </div>

                <div *ngIf="successMessage" class="notification is-success is-light">
                    <button class="delete" (click)="successMessage = ''"></button>
                    {{ successMessage }}
                </div>

                <div *ngIf="alumnosConFaltantes.length > 0" class="notification" style="background-color: #ff9800; color: white; padding: 1rem;">
                    <div class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                <span class="icon" style="font-size: 2rem; margin-right: 1rem;">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                                <span style="font-size: 1.1rem; font-weight: 500;">Existen alumnos con información faltante</span>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <button class="button is-small" style="background-color: rgba(255,255,255,0.2); color: white; border: 1px solid rgba(255,255,255,0.5);" 
                                        (click)="abrirModalFaltantes()"
                                        title="Ver alumnos con información faltante">
                                    <span class="icon">
                                        <i class="fas fa-list"></i>
                                    </span>
                                    <span>Ver detalles ({{ alumnosConFaltantes.length }})</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="estadisticas-container">
                    <div class="estadistica-card">
                        <div class="estadistica-content">
                            <div class="estadistica-icon has-text-info">
                                <i class="fas fa-graduation-cap fa-2x"></i>
                            </div>
                            <div class="estadistica-text">
                                <div class="estadistica-value">{{ total_carreras }}</div>
                                <div class="estadistica-label">Carreras</div>
                            </div>
                        </div>
                    </div>

                    <div class="estadistica-card">
                        <div class="estadistica-content">
                            <div class="estadistica-icon has-text-info">
                                <i class="fas fa-clock fa-2x"></i>
                            </div>
                            <div class="estadistica-text">
                                <div class="estadistica-value">{{ total_periodos }}</div>
                                <div class="estadistica-label">Periodos</div>
                            </div>
                        </div>
                    </div>

                    <div class="estadistica-card">
                        <div class="estadistica-content">
                            <div class="estadistica-icon has-text-info">
                                <i class="fas fa-flag fa-2x"></i>
                            </div>
                            <div class="estadistica-text">
                                <div class="estadistica-value">{{ total_inscripciones }}</div>
                                <div class="estadistica-label">Inscripciones</div>
                            </div>
                        </div>
                    </div>

                    <div class="estadistica-card">
                        <div class="estadistica-content">
                            <div class="estadistica-icon has-text-info">
                                <i class="fas fa-redo fa-2x"></i>
                            </div>
                            <div class="estadistica-text">
                                <div class="estadistica-value">{{ total_reinscripciones }}</div>
                                <div class="estadistica-label">Reinscripciones</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h2 class="card-header-title">Detalles por Programas Académicos y Periodos</h2>
                    </div>
                    <div class="card-content">
                        <div class="table-container">
                            <div class="fixed-header-table">
                                <table class="table is-fullwidth is-striped">
                                    <thead>
                                        <tr>
                                            <th>PROGRAMA ACADÉMICO</th>
                                            <th>RVOE</th>
                                            <th>PERIODO</th>
                                            <th>INSCRIPCIONES</th>
                                            <th>REINSCRIPCIONES</th> 
                                            <th>OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of data_tabla">
                                            <td>{{ item.programa_academico || 'N/A' }}</td>
                                            <td>{{ item.rvoe || 'N/A' }}</td>
                                            <td>{{ item.periodo || 'N/A' }}</td>
                                            <td>{{ item.inscripciones || 0 }}</td>
                                            <td>{{ item.reinscripciones || 0 }}</td>
                                            <td>
                                                <button class="button is-small btn-opciones" 
                                                        (click)="abrirModalAlumnos(item)"
                                                        title="Ver alumnos">
                                                    <span class="icon">
                                                        <i class="fas fa-list"></i>
                                                    </span>
                                                    <span>Ver alumnos</span>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr *ngIf="data_tabla.length === 0">
                                            <td colspan="6" class="has-text-centered">
                                                No hay datos disponibles. Por favor, realice una consulta primero.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Modal para alumnos por programa/periodo -->
<div class="modal modal-alumnos" [class.is-active]="showAlumnosModal">
    <div class="modal-background"></div>
    <div class="modal-card modal-card-alumnos">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ modalTitle }}</p>
            <div>
                <button class="button is-small btn-excel mr-2" 
                        (click)="exportarExcel(selectedItem)"
                        title="Exportar a Excel">
                    <span class="icon">
                        <i class="fas fa-file-excel"></i>
                    </span>
                    <span>Excel</span>
                </button>
                <button class="delete" aria-label="close" (click)="cerrarModalAlumnos()"></button>
            </div>
        </header>
        <section class="modal-card-body modal-card-body-alumnos">
            <div class="table-container-alumnos">
                <table class="table table-alumnos is-fullwidth">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Grupo</th>
                            <th>Estatus</th>
                            <th>Año del ciclo escolar</th>
                            <th>Nombre del alumno</th>
                            <th>Primer Apellido</th>
                            <th>Segundo Apellido</th>
                            <th>Género</th>
                            <th>CURP</th>
                            <th>Fecha de Nacimiento</th>
                            <th>País de Nacimiento</th>
                            <th>Entidad Federativa o Ciudad de Nacimiento</th>
                            <th>País de Procedencia</th>
                            <th>Idioma/Lengua</th>
                            <th>Necesidad Educativa Especial</th>
                            <th>Presenta Antecedente Académico</th>
                            <th>CCT</th>
                            <th>Matrícula Institucional</th>
                            <th>Nivel Educativo</th>
                            <th>Clave de la Institución</th>
                            <th>Clave de Carrera</th>
                            <th>Turno</th>
                            <th>Número de Acuerdo de RVOE</th>
                            <th>Fecha de Acuerdo de RVOE</th>
                            <th>Modalidad Educativa</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let alumno of alumnosData; let i = index">
                            <td>{{ i+1 }}</td>
                            <td>{{ alumno.grupo || 'N/D' }}</td>
                            <td>{{ alumno.estatus || 'N/D' }}</td>
                            <td>{{ alumno.anio_ciclo_escolar }}</td>
                            <td>{{ alumno.nombre_alumno || 'N/D' }}</td>
                            <td>{{ alumno.primer_apellido || 'N/D' }}</td>
                            <td>{{ alumno.segundo_apellido || 'N/D' }}</td>
                            <td>{{ alumno.genero || 'N/D' }}</td>
                            <td>{{ alumno.curp || 'N/D' }}</td>
                            <td>{{ alumno.fecha_nacimiento || 'N/D' }}</td>
                            <td>{{ alumno.pais_nacimiento || 'N/D' }}</td>
                            <td>{{ alumno.entidad_federativa || 'N/D' }}</td>
                            <td>{{ alumno.pais_procedencia || 'N/D' }}</td>
                            <td>{{ alumno.idioma || 'N/D' }}</td>
                            <td>{{ alumno.necesidad_educativa_especial || 'N/D' }}</td>
                            <td>{{ alumno.presenta_antecedente_academico || 'N/D' }}</td>
                            <td>{{ alumno.cct || 'N/D' }}</td>
                            <td>{{ alumno.matricula_institucional || 'N/D' }}</td>
                            <td>{{ alumno.nivel_educativo || 'N/D' }}</td>
                            <td>{{ alumno.clave_institucion || 'N/D' }}</td>
                            <td>{{ alumno.clave_carrera || 'N/D' }}</td>
                            <td>{{ alumno.turno || 'N/D' }}</td>
                            <td>{{ alumno.numero_acuerdo_rvoe || 'N/D' }}</td>
                            <td>{{ alumno.fecha_acuerdo_rvoe || 'N/D' }}</td>
                            <td>{{ alumno.modalidad_educativa || 'N/D' }}</td>
                        </tr>
                        <tr *ngIf="alumnosData.length === 0">
                            <td colspan="24" class="has-text-centered">
                                No hay datos de alumnos disponibles.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalAlumnos()">Cerrar</button>
        </footer>
    </div>
</div>

<!-- Modal para alumnos con información faltante -->
<div class="modal modal-alumnos" [class.is-active]="showFaltantesModal">
    <div class="modal-background"></div>
    <div class="modal-card modal-card-alumnos">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ faltantesModalTitle }}</p>
            <div>
                <button class="button is-small btn-excel mr-2" 
                        (click)="exportarExcelFaltantes()"
                        title="Exportar a Excel">
                    <span class="icon">
                        <i class="fas fa-file-excel"></i>
                    </span>
                    <span>Excel</span>
                </button>
                <button class="delete" aria-label="close" (click)="cerrarModalFaltantes()"></button>
            </div>
        </header>
        <section class="modal-card-body modal-card-body-alumnos">
            <div class="table-container-alumnos">
                <table class="table table-alumnos is-fullwidth">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Estatus</th>
                            <th>Año del ciclo escolar</th>
                            <th>Nombre del alumno</th>
                            <th>Primer Apellido</th>
                            <th>Segundo Apellido</th>
                            <th>Género</th>
                            <th>CURP</th>
                            <th>Fecha de Nacimiento</th>
                            <th>País de Nacimiento</th>
                            <th>Entidad Federativa o Ciudad de Nacimiento</th>
                            <th>País de Procedencia</th>
                            <th>Idioma/Lengua</th>
                            <th>Necesidad Educativa Especial</th>
                            <th>Presenta Antecedente Académico</th>
                            <th>CCT</th>
                            <th>Matrícula Institucional</th>
                            <th>Nivel Educativo</th>
                            <th>Clave de la Institución</th>
                            <th>Clave de Carrera</th>
                            <th>Turno</th>
                            <th>Número de Acuerdo de RVOE</th>
                            <th>Fecha de Acuerdo de RVOE</th>
                            <th>Modalidad Educativa</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let alumno of alumnosData; let i = index">
                            <td>{{ i+1 }}</td>
                            <td>{{ alumno.estatus || 'N/A' }}</td>
                            <td>{{ alumno.anio_ciclo_escolar }}</td>
                            <td>{{ alumno.nombre_alumno || 'N/A' }}</td>
                            <td>{{ alumno.primer_apellido || 'N/A' }}</td>
                            <td>{{ alumno.segundo_apellido || 'N/A' }}</td>
                            <td>{{ alumno.genero || 'N/D' }}</td>
                            <td>{{ alumno.curp || 'N/A' }}</td>
                            <td>{{ alumno.fecha_nacimiento || 'N/A' }}</td>
                            <td>{{ alumno.pais_nacimiento || 'N/A' }}</td>
                            <td>{{ alumno.entidad_federativa || 'N/A' }}</td>
                            <td>{{ alumno.pais_procedencia || 'N/A' }}</td>
                            <td>{{ alumno.idioma || 'N/A' }}</td>
                            <td>{{ alumno.necesidad_educativa_especial || 'N/A' }}</td>
                            <td>{{ alumno.presenta_antecedente_academico || 'N/A' }}</td>
                            <td>{{ alumno.cct || 'N/A' }}</td>
                            <td>{{ alumno.matricula_institucional || 'N/A' }}</td>
                            <td>{{ alumno.nivel_educativo || 'N/A' }}</td>
                            <td>{{ alumno.clave_institucion || 'N/A' }}</td>
                            <td>{{ alumno.clave_carrera || 'N/A' }}</td>
                            <td>{{ alumno.turno || 'N/A' }}</td>
                            <td>{{ alumno.numero_acuerdo_rvoe || 'N/A' }}</td>
                            <td>{{ alumno.fecha_acuerdo_rvoe || 'N/A' }}</td>
                            <td>{{ alumno.modalidad_educativa || 'N/A' }}</td>
                        </tr>
                        <tr *ngIf="alumnosData.length === 0">
                            <td colspan="24" class="has-text-centered">
                                No hay datos de alumnos disponibles.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalFaltantes()">Cerrar</button>
        </footer>
    </div>
</div>